export const errMsg = {
    buyer_type: 'กรุณาเลือกประเภท',
    buyer_tax_id: 'กรุณากรอกเลขที่บัตรประชาชน/เลขประจำตัวผู้เสียภาษีให้ถูกต้อง',
    buyer_tax_id1: 'กรุณากรอกเลขที่หนังสือเดินทาง',
    card_tax: 'เลขที่บัตรประชาชน/เลขประจำตัวผู้เสียภาษี ไม่ถูกต้อง',
    buyer_company_name: 'กรุณากรอกชื่อ-นามสกุล/ชื่อบริษัท',
    buyer_main_branch_no: 'กรุณาเลือกลำดับเลขที่สาขา',
    buyer_branch_no: 'กรุณากรอกเลขที่สาขา',
    house_no: 'กรุณากรอกบ้านเลขที่',
    postcode: 'กรุณากรอกรหัสไปรษณีย์',
    notpostcode: 'รหัสไปรษณีย์ไม่มีในระบบ',
    postcodeEmpty: 'รหัสไปรษณีย์ไม่มีในระบบ',
    district: 'กรุณาเลือกอำเภอ',
    sub_district: 'กรุณาเลือกตำบล',
    province: 'กรุณาเลือกจังหวัด',
    notprovince: 'จังหวัดไม่ถูกต้อง',
    buyer_agree_tmp: 'ผู้ซื้อยินยอมให้บันทึกข้อมูลส่วนบุคคลไว้ในระบบหรือไม่?',
    template_lang: 'ผู้ซื้อต้องการออกใบกำกับภาษีภาษาใด?',
    addrENProvince: 'กรุณากรอก State/Province',
    addrENPostCode: 'กรุณากรอก Post Code',
    addrENCountry: 'กรุณาเลือก Country',
    Other: 'กรุณากรอกอื่นๆ',
    error: "ไม่สามารถเชื่อมต่อได้ กรุณาทำรายการใหม่ หรือกดยืนยันใหม่อีกครั้ง",
    pleaseInput: "กรุณาระบุอย่างน้อยหนึ่งช่อง",
    pleasePhone: "กรุณากรอกเบอร์โทรศัพท์ให้ถูกต้อง",
    errorLengthAbb: "สามารถค้นหาใบเสร็จรับเงินและใบกำกับภาษีอย่างย่อได้ครั้งละ 10 รายการ",
    errorLengthAbbOderNo: "หากคุณทำการเลือกเพิ่มข้อมูล order no. คุณจะสามารถค้นหาใบเสร็จได้แค่ 1 รายการเท่านั้น",
    errorAbb: "รูปแบบใบเสร็จรับเงิน/ใบกำกับภาษีอย่างย่อไม่ถูกต้อง",
    errorEmail: "รูปแบบ email ไม่ถูกต้อง",
    errorSearchReplaceEmpty: "กรุณาเลือกสาเหตุการออกเอกสารใบทดแทน",
    errorSearchReplaceOther: "กรุณากรอกอื่นๆโปรดระบุ",
    errorReplaceTaxNumberEmpty: "กรุณากรอกเลขที่ใบกำกับภาษีเต็มรูป",
    errorReplaceNumberAbbEmpty: "กรุณากรอกเลขที่ใบเสร็จรับเงิน/ใบกำกับภาษีอย่างย่อ",
    errorConfirmSendEmail: "ระบบได้ดำเนินการส่งรายละเอียด เพื่อสร้างเอกสารอิเล็กทรอนิกส์เรียบร้อยแล้ว โดยนำส่งตาม E-mail ที่มีการระบุไว้",
    errorCaseID: "กรุณากรอก case ID",
    errorReceiptNo: "กรุณากรอก Receipt No. / Tp No. / Barcode No.",
    errorLogin_ad2: "ไม่สามารถ Login เข้าระบบได้ กรุณา Login เข้าระบบใหม่อีกครั้ง",
    errorAddressline1: "กรุณากรอก ที่อยู่"


}